import React, { useEffect, useState } from "react";
import API from "../services/api";

function SalesManagerDashboard() {
  const [stats, setStats] = useState({
    totalLeads: 0,
    assignedLeads: 0,
    closedDeals: 0,
    pendingFollowups: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [leadsRes, dealsRes, followupsRes] = await Promise.all([
          API.get("/leads").catch(() => ({ data: [] })),
          API.get("/deals").catch(() => ({ data: [] })),
          API.get("/followups").catch(() => ({ data: [] })),
        ]);

        const leads = leadsRes.data || [];
        const deals = dealsRes.data || [];
        const followups = followupsRes.data || [];

        setStats({
          totalLeads: leads.length,
          assignedLeads: leads.filter((l) => l.assigned_to).length,
          closedDeals: deals.length,
          pendingFollowups: followups.filter((f) => f.status !== "Completed").length,
        });
      } catch (err) {
        console.log("Sales Manager dashboard fetch error:", err);
      }
    };

    fetchStats();
  }, []);

  return (
    <div>
      <h3 style={{ marginBottom: 20 }}>Sales Manager Dashboard</h3>

      <div className="dashboard-cards" style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: 16,
      }}>
        <div className="card" style={{ background: "#fff", borderRadius: 10, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          <h3 style={{ margin: 0, fontSize: 13, color: "#64748b" }}>Total Leads</h3>
          <p style={{ margin: "8px 0 0", fontSize: 26, fontWeight: 700 }}>{stats.totalLeads}</p>
        </div>

        <div className="card" style={{ background: "#fff", borderRadius: 10, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          <h3 style={{ margin: 0, fontSize: 13, color: "#64748b" }}>Assigned Leads</h3>
          <p style={{ margin: "8px 0 0", fontSize: 26, fontWeight: 700 }}>{stats.assignedLeads}</p>
        </div>

        <div className="card" style={{ background: "#fff", borderRadius: 10, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          <h3 style={{ margin: 0, fontSize: 13, color: "#64748b" }}>Closed Deals</h3>
          <p style={{ margin: "8px 0 0", fontSize: 26, fontWeight: 700 }}>{stats.closedDeals}</p>
        </div>

        <div className="card" style={{ background: "#fff", borderRadius: 10, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          <h3 style={{ margin: 0, fontSize: 13, color: "#64748b" }}>Pending Followups</h3>
          <p style={{ margin: "8px 0 0", fontSize: 26, fontWeight: 700 }}>{stats.pendingFollowups}</p>
        </div>
      </div>
    </div>
  );
}

export default SalesManagerDashboard;
